import { Navigate, generatePath, useParams } from 'react-router-dom';

export const RedirectWithCurrentParams = ({ to }: { to: string }): JSX.Element => {
  const params = useParams();
  return <Navigate replace to={generatePath(to, params)} />;
};
